(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;

  /* -----------------------------------------------------------------------
     Human-readable labels for stored values
     ----------------------------------------------------------------------- */
  var PACKAGE_LABELS = {
    'clear': 'Clear', 'blue-light': 'Blue Light', 'photochromic': 'Photochromic',
    'non-polarized': 'Non-Polarized', 'polarized': 'Polarized'
  };

  var LENS_TYPE_LABELS = {
    'standard': 'Standard', 'premium': 'Premium', 'premium-ar': 'Premium AR', 'ultra-thin': 'Ultra-Thin'
  };

  var PACKAGE_ORDER = {
    'clear': 1,
    'blue-light': 2,
    'photochromic': 3,
    'non-polarized': 4,
    'polarized': 5
  };

  var LENS_TYPE_ORDER = {
    'standard': 1,
    'premium': 2,
    'premium-ar': 3,
    'ultra-thin': 4
  };

  var LENS_TYPE_DESCRIPTIONS = {
    'standard': 'Impact-resistant lenses for everyday prescriptions.',
    'premium': 'Lighter lenses with anti-reflective coating for sharper, more comfortable vision. 1.59 index.',
    'premium-ar': 'Anti-reflective, scratch-resistant, and optimized for clear vision.',
    'ultra-thin': 'Our thinnest, lightest lenses with anti-reflective coating, ideal for stronger prescriptions. 1.67 high-index material.'
  };

  var LENS_TYPE_ICONS = {
    'standard': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'premium': '<svg width="47" height="27" viewBox="0 0 47 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.6602 19.9013L38.5602 7.5813" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.4598 11.7012C44.7198 17.6612 40.8898 22.8912 35.3198 25.1412C33.9898 25.6812 30.6398 26.0412 29.4298 26.0412H17.8698C14.1598 25.9212 11.3498 25.1712 8.6498 23.3312C6.4198 21.8112 4.5898 19.9412 3.2498 17.6212C1.4898 14.5912 0.549805 11.1212 0.549805 7.5212C0.549805 3.6212 4.28981 0.481197 8.84981 0.551197L37.6498 0.941197C45.1398 0.681197 46.1298 6.4112 45.4798 11.7112L45.4598 11.7012Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'premium-ar': '<svg width="47" height="27" viewBox="0 0 47 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.6602 19.9013L38.5602 7.5813" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M45.4598 11.7012C44.7198 17.6612 40.8898 22.8912 35.3198 25.1412C33.9898 25.6812 30.6398 26.0412 29.4298 26.0412H17.8698C14.1598 25.9212 11.3498 25.1712 8.6498 23.3312C6.4198 21.8112 4.5898 19.9412 3.2498 17.6212C1.4898 14.5912 0.549805 11.1212 0.549805 7.5212C0.549805 3.6212 4.28981 0.481197 8.84981 0.551197L37.6498 0.941197C45.1398 0.681197 46.1298 6.4112 45.4798 11.7112L45.4598 11.7012Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'ultra-thin': '<svg width="54" height="28" viewBox="0 0 54 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M41.9798 10.841C41.2998 16.341 37.7598 21.161 32.6298 23.241C31.3998 23.741 28.3198 24.071 27.1898 24.071H16.5298C13.0998 23.961 10.5198 23.271 8.01981 21.571C5.95981 20.171 4.27981 18.441 3.03981 16.301C1.41981 13.501 0.549805 10.301 0.549805 6.98097C0.549805 3.38097 3.9998 0.490966 8.1998 0.550966L34.7698 0.910966C41.6798 0.670966 42.5998 5.96097 41.9898 10.841H41.9798Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M53.1898 13.9611C52.5098 19.4611 48.9698 24.2811 43.8398 26.3611C42.6098 26.8611 39.5298 27.1911 38.3998 27.1911H27.7398C24.3098 27.0811 21.7298 26.3911 19.2298 24.6911C17.1698 23.2911 15.4898 21.5611 14.2498 19.4211C12.6298 16.6211 11.7598 13.4211 11.7598 10.1011C11.7598 6.50108 15.2098 3.61108 19.4098 3.67108L45.9798 4.03108C52.8898 3.79108 53.8098 9.08108 53.1998 13.9611H53.1898Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var RX_CUT_LIMITS = { sphMin: -6, sphMax: 3, cylMax: 2 };

  var PACKAGE_ICONS = {
    'clear': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'blue-light': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="9" y="10" width="42" height="30" rx="3" stroke="currentColor" stroke-width="1.1"/><path d="M5 40h50v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5Z" stroke="currentColor" stroke-width="1.1"/></svg>',
    'photochromic': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="19" cy="30" r="6" stroke="currentColor" stroke-width="1.1"/><path d="M19 19v-3M19 44v-3M8 30H5M33 30h-3M11 22l-2-2M29 40l-2-2M11 38l-2 2M29 20l-2 2" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/><path d="M44.5 40c-6.08 0-11-4.92-11-11s4.92-11 11-11c2.06 0 3.99.57 5.64 1.56a11 11 0 0 0 0 18.88A10.93 10.93 0 0 1 44.5 40Z" stroke="currentColor" stroke-width="1.1"/></svg>',
    'non-polarized': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" fill-opacity="0.06"/></svg>',
    'polarized': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" fill-opacity="0.06"/><line x1="14" y1="25" x2="46" y2="25" stroke="currentColor" stroke-width="0.7" opacity="0.35"/><line x1="12" y1="30" x2="48" y2="30" stroke="currentColor" stroke-width="0.7" opacity="0.35"/><line x1="14" y1="35" x2="46" y2="35" stroke="currentColor" stroke-width="0.7" opacity="0.35"/></svg>'
  };

  // Derive labels from the prescription-type step's TYPES array (single source of truth).
  // Falls back to built-in map if the step module hasn't loaded yet.
  function buildRxTypeLabels() {
    var buildTypes = window.WmpSteps && window.WmpSteps['prescription-type'] && window.WmpSteps['prescription-type'].types;
    var types = typeof buildTypes === 'function' ? buildTypes() : buildTypes;
    if (types && types.length) {
      var map = {};
      for (var i = 0; i < types.length; i++) {
        map[types[i].key] = types[i].name.charAt(0) + types[i].name.slice(1).toLowerCase();
      }
      return map;
    }
    return { 'single-vision': 'Single Vision', 'reading': 'Reading', 'progressive': 'Progressive', 'non-prescription': 'Non-Prescription' };
  }

  function findByVariantId(list, variantId) {
    if (!list || !variantId) return null;
    var target = String(variantId);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].variantId || '') === target) return list[i];
    }
    return null;
  }

  function resolveLensPackageLabel(state) {
    var cfg = window.WmpProductsConfig;
    var byVariant = cfg && cfg.lensPackages
      ? findByVariantId(cfg.lensPackages, state.lensPackageVariantId)
      : null;
    if (byVariant && byVariant.title) return byVariant.title;

    var byKeys = cfg && typeof cfg.findLensPackage === 'function'
      ? cfg.findLensPackage(state.frameType, state.prescriptionType, state.lensPackage)
      : null;
    if (byKeys && byKeys.title) return byKeys.title;

    return PACKAGE_LABELS[state.lensPackage] || state.lensPackage;
  }

  function resolveLensTypeLabel(state) {
    var cfg = window.WmpProductsConfig;
    var byVariant = cfg && cfg.lensTypes
      ? findByVariantId(cfg.lensTypes, state.lensTypeVariantId)
      : null;
    if (byVariant && byVariant.title) return byVariant.title;

    var byKeys = cfg && typeof cfg.findLensType === 'function'
      ? cfg.findLensType(state.frameType, state.prescriptionType, state.lensPackage, state.lensType)
      : null;
    if (byKeys && byKeys.title) return byKeys.title;

    return LENS_TYPE_LABELS[state.lensType] || state.lensType;
  }

  var ACCESSORY_LABELS = {
    'zipper-case': 'Zipper Case', 'cleaning-kit': 'Cleaning Kit',
    'premium-foldable-case': 'Premium Foldable Case', 'placeholder': 'Placeholder'
  };

  var LENSES_FIELD_MAP = {
    'single-vision': 'Single Vision', 'reading': 'Reading', 'progressive': 'Progressive'
  };

  /* SVGs */
  var PENCIL_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.5 2.5l2 2L5 13H3v-2l8.5-8.5z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>';
  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TRUCK_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 3h9v8H1zM10 6h3l2 3v3h-5" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><circle cx="4" cy="12.5" r="1.5" stroke="currentColor" stroke-width="1.2"/><circle cx="12" cy="12.5" r="1.5" stroke="currentColor" stroke-width="1.2"/></svg>';
  var CHEVRON_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MOBILE_SUBTOTAL_CHEVRON_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK_BORDER_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="9" stroke="black" /><path d="M8.5 13L10.5 15L15.5 10" stroke="black" stroke-linecap="round" stroke-linejoin="round" /></svg>';
  var BOX_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_16848_11394)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9208 2.00558C11.8807 2.01298 11.8416 2.02671 11.8067 2.04784L9.07257 3.66529L9.04933 3.65155L9.02397 3.69381L3.17009 7.15691C3.0655 7.21924 3.00106 7.33334 3.00211 7.45483H3V16.5478H3.00423C3.00423 16.6683 3.06656 16.7803 3.17009 16.8426L11.8056 21.9517C11.9134 22.0161 12.0486 22.0161 12.1564 21.9517L20.7888 16.8426C20.8934 16.7813 20.9568 16.6683 20.9578 16.5478H20.9589V7.45589H20.9568C20.9568 7.33334 20.8934 7.2203 20.7888 7.15797L12.1564 2.04784C12.0856 2.00558 12.0011 1.99079 11.9198 2.00558H11.9208ZM11.981 2.74511L19.9362 7.45483L17.705 8.77542C17.6976 8.77013 17.6902 8.76485 17.6828 8.76063L9.74976 4.06675L11.981 2.74511ZM9.07257 4.46715L17.0299 9.17476L15.4029 10.1372L7.44772 5.42959L9.07257 4.46715ZM6.76736 5.83104L14.7247 10.5387L11.981 12.1614L4.02372 7.45589L6.76736 5.83104ZM3.68987 8.05702L11.6345 12.7572V21.0494L3.68987 16.3492V8.05702ZM20.2701 8.05808V16.3503L12.3254 21.0516V12.7594L15.0268 11.1609V14.4708C15.0268 14.4824 15.0279 14.4951 15.03 14.5067C15.0321 14.5237 15.0342 14.5395 15.0384 14.5564C15.0427 14.5722 15.0469 14.5881 15.0532 14.6029C15.0585 14.6177 15.0659 14.6314 15.0733 14.6451L15.0744 14.6483L15.0765 14.6515C15.0849 14.6642 15.0934 14.6768 15.1029 14.6885C15.1134 14.7011 15.124 14.7138 15.1367 14.7244C15.1483 14.736 15.162 14.7455 15.1747 14.755C15.1874 14.7645 15.2011 14.773 15.2149 14.7804C15.2297 14.7878 15.2455 14.7941 15.2624 14.7994C15.2783 14.8047 15.2941 14.8089 15.3099 14.811C15.3226 14.8131 15.3364 14.8152 15.3501 14.8152C15.3543 14.8152 15.3585 14.8152 15.3628 14.8152C15.3659 14.8152 15.3691 14.8152 15.3733 14.8152C15.3839 14.8152 15.3934 14.8152 15.404 14.8131C15.4071 14.8131 15.4093 14.8131 15.4124 14.8131H15.4167C15.4304 14.811 15.4431 14.8089 15.4568 14.8057H15.4579C15.461 14.8047 15.4652 14.8036 15.4684 14.8026C15.479 14.7994 15.4895 14.7962 15.4991 14.792C15.5012 14.792 15.5022 14.792 15.5043 14.7909C15.5065 14.7899 15.5096 14.7888 15.5117 14.7878C15.5149 14.7867 15.5181 14.7846 15.5223 14.7835C15.5307 14.7793 15.5392 14.7751 15.5477 14.7698L17.6743 13.5094C17.6743 13.5094 17.6807 13.5063 17.6828 13.5052C17.6859 13.5031 17.6881 13.502 17.6912 13.4999C17.6965 13.4968 17.7018 13.4925 17.7071 13.4894L17.7102 13.4873C17.7145 13.4841 17.7187 13.4809 17.7219 13.4777H17.7229C17.7271 13.4735 17.7324 13.4693 17.7367 13.4661C17.7398 13.463 17.744 13.4598 17.7472 13.4556L17.7504 13.4524C17.7779 13.4249 17.8 13.3932 17.8169 13.3584C17.8191 13.3552 17.8201 13.352 17.8212 13.3489C17.8222 13.3457 17.8233 13.3436 17.8243 13.3404C17.8265 13.3341 17.8286 13.3288 17.8307 13.3224C17.8349 13.3108 17.8381 13.2982 17.8412 13.2865V13.2855C17.8486 13.2538 17.8507 13.221 17.8497 13.1893V9.49276L20.2679 8.0623L20.2701 8.05808ZM17.1619 9.89738V13.0118L15.7156 13.8676V10.7531L17.1619 9.89738Z" fill="black" /></g><defs><clipPath id="clip0_16848_11394"><rect width="18" height="20" fill="white" transform="translate(3 2)" /></clipPath></defs></svg>';

  var confirmCheckbox = null;
  var editIconHtml = PENCIL_SVG;
  var pendingReviewFocusRow = null;

  // Submit-button + error refs, hoisted so onSubmit() can toggle loading/error
  // state without re-querying the DOM.
  var checkoutBtn = null;
  var cartBtn = null;
  var submitErrorEl = null;
  var submitting = false;

  function decodeHtmlEntities(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value || t.textContent || '';
  }

  function bindReviewInfoBubble(trigger, content) {
    if (!trigger) return;

    function show(e) {
      e.stopPropagation();
      if (e.type === 'click') e.preventDefault();
      if (!window.WmpInfoBubble) return;
      WmpInfoBubble.show(e.currentTarget, {
        content: content,
        toggle: false
      });
    }

    trigger.addEventListener('click', show);
    trigger.addEventListener('mouseenter', show);
    trigger.addEventListener('focus', show);
    trigger.addEventListener('mouseleave', function (e) {
      if (document.activeElement !== e.currentTarget && window.WmpInfoBubble) WmpInfoBubble.hide();
    });
    trigger.addEventListener('blur', function () {
      if (window.WmpInfoBubble) WmpInfoBubble.hide();
    });
  }

  function getConfirmControl() {
    return confirmCheckbox ? confirmCheckbox.closest('.wmp-review-confirm') : null;
  }

  function getReviewRowKey(label) {
    return String(label || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function queueReviewFocus(rowKey) {
    pendingReviewFocusRow = rowKey;
  }

  function restoreQueuedReviewFocus() {
    if (!pendingReviewFocusRow) return;

    var rowKey = pendingReviewFocusRow;
    pendingReviewFocusRow = null;

    requestAnimationFrame(function () {
      var target = document.querySelector('[data-review-row="' + rowKey + '"]');
      if (!target || typeof target.focus !== 'function') return;

      if (typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      target.focus({ preventScroll: true });
    });
  }

  function sanitizeTitle(str) {
    if (!str && str !== 0) return '';
    try {
      return String(str).replace(/\s*\|\s*(?:RX|Rx|PRESCRIPTION|Prescription).*/g, '').trim();
    } catch (e) {
      return String(str || '');
    }
  }

  function getSortedLensPackages(state) {
    var cfg = window.WmpProductsConfig;
    if (!cfg || typeof cfg.getLensPackages !== 'function') return [];
    var list = cfg.getLensPackages({
      frameType: state.frameType || 'clear',
      prescriptionType: state.prescriptionType || 'single-vision'
    }) || [];
    list.sort(function (a, b) {
      var ao = PACKAGE_ORDER[a.packageKey] || 999;
      var bo = PACKAGE_ORDER[b.packageKey] || 999;
      if (ao !== bo) return ao - bo;
      return (a.title || a.packageKey || '').localeCompare(b.title || b.packageKey || '');
    });
    return list;
  }

  function getSortedLensTypes(state, lensPackageKey) {
    var cfg = window.WmpProductsConfig;
    if (!cfg || typeof cfg.getLensTypes !== 'function') return [];
    var list = cfg.getLensTypes({
      frameType: state.frameType || 'clear',
      prescriptionType: state.prescriptionType || 'single-vision',
      lensPackageKey: lensPackageKey
    }) || [];

    if (state.prescriptionType === 'reading' && state.frameType === 'clear') {
      list = list.filter(function (item) {
        return item.lensTypeKey !== 'premium-ar';
      });
    }

    list.sort(function (a, b) {
      var ao = LENS_TYPE_ORDER[a.lensTypeKey] || 999;
      var bo = LENS_TYPE_ORDER[b.lensTypeKey] || 999;
      if (ao !== bo) return ao - bo;
      return (a.title || a.lensTypeKey || '').localeCompare(b.title || b.lensTypeKey || '');
    });

    if (restrictToUltraThin(state.prescriptionType, state.rxValues)) {
      list = list.filter(function (item) {
        return item.lensTypeKey === 'ultra-thin';
      });
    }

    return list;
  }

  function restrictToUltraThin(rxType, rxValues) {
    if (rxType === 'non-prescription') return false;
    if (!rxValues) return false;

    var limits = RX_CUT_LIMITS;
    var eyes = [rxValues.od, rxValues.os];

    for (var i = 0; i < eyes.length; i++) {
      var eye = eyes[i] || {};
      if (eye.sph !== null && (eye.sph < limits.sphMin || eye.sph > limits.sphMax)) return true;
      if (eye.cyl !== null && Math.abs(eye.cyl) > limits.cylMax) return true;
    }

    return false;
  }

  function resolveNextLensType(state, lensPackageKey) {
    var list = getSortedLensTypes(state, lensPackageKey);
    if (!list.length) return null;

    for (var i = 0; i < list.length; i++) {
      if (list[i].lensTypeKey === state.lensType) return list[i];
    }
    for (var j = 0; j < list.length; j++) {
      if (list[j].lensTypeKey === 'standard') return list[j];
    }
    return list[0];
  }

  function rerenderReviewStep() {
    if (store.get('currentStep') === 'review') {
      store.set('currentStep', 'review');
    }
  }

  function applyLensPackageFromReview(pkg) {
    if (!pkg) return;

    queueReviewFocus('lens-package');

    var state = store.getState();
    var pricing = store.get('pricing');
    var nextLensType = resolveNextLensType(state, pkg.packageKey);

    store.set('lensPackage', pkg.packageKey);
    store.set('lensPackageVariantId', String(pkg.variantId || ''));

    pricing.lensPackage = pkg.priceCents || 0;
    if (nextLensType) {
      store.set('lensType', nextLensType.lensTypeKey);
      store.set('lensTypeVariantId', String(nextLensType.variantId || ''));
      pricing.lensType = nextLensType.priceCents || 0;
    } else {
      store.set('lensType', null);
      store.set('lensTypeVariantId', null);
      pricing.lensType = 0;
    }

    store.set('pricing', pricing);
    if (typeof store.recalcLenses === 'function') {
      store.recalcLenses();
    }
    rerenderReviewStep();
  }

  function openLensPackageModal() {
    if (!window.WmpModal || typeof window.WmpModal.open !== 'function') {
      store.set('editingFromReview', true);
      router.navigate('lens-package');
      return;
    }

    var state = store.getState();
    var packages = getSortedLensPackages(state);
    if (!packages.length) return;

    var content = document.createElement('div');
    content.className = 'wmp-review-package-modal';

    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    for (var i = 0; i < packages.length; i++) {
      (function (pkg) {
        var displayName = (pkg.title || pkg.packageKey || '').toString().toUpperCase();
        var card = document.createElement('button');
        card.className = 'wmp-card';
        card.setAttribute('type', 'button');
        if (state.lensPackage === pkg.packageKey) {
          card.classList.add('wmp-card--selected');
        }

        var iconEl = document.createElement('span');
        iconEl.className = 'wmp-card__icon';
        iconEl.innerHTML = PACKAGE_ICONS[pkg.packageKey] || PACKAGE_ICONS['clear'];
        card.appendChild(iconEl);

        var body = document.createElement('div');
        body.className = 'wmp-card__content';

        var title = document.createElement('span');
        title.className = 'wmp-card__title';
        title.textContent = displayName;
        body.appendChild(title);

        if (pkg.subtitle) {
          var desc = document.createElement('span');
          desc.className = 'wmp-card__description';
          desc.style.cssText = 'display:block;margin-top:10px;';
          desc.textContent = pkg.subtitle;
          body.appendChild(desc);
        }

        if (pkg.note) {
          var note = document.createElement('span');
          note.className = 'wmp-card__description';
          note.style.cssText = 'display:block;margin-top:6px;font-size:12px;line-height:16px;';
          note.textContent = '*' + pkg.note;
          body.appendChild(note);
        }

        card.appendChild(body);

        var price = document.createElement('div');
        price.className = 'wmp-card__price';
        if (pkg.comparePriceCents && pkg.comparePriceCents > pkg.priceCents) {
          var sale = document.createElement('span');
          sale.className = 'wmp-card__price--sale';
          sale.textContent = store.formatPrice(pkg.priceCents || 0);
          price.appendChild(sale);
          price.appendChild(document.createTextNode(' '));

          var original = document.createElement('span');
          original.className = 'wmp-card__price-original';
          original.textContent = store.formatPrice(pkg.comparePriceCents || 0);
          price.appendChild(original);
        } else {
          price.textContent = store.formatPrice(pkg.priceCents || 0);
        }
        card.appendChild(price);

        card.addEventListener('click', function () {
          applyLensPackageFromReview(pkg);
          window.WmpModal.close();
        });

        list.appendChild(card);
      })(packages[i]);
    }

    content.appendChild(list);

    window.WmpModal.open({
      title: 'CHOOSE LENS PACKAGE',
      content: content,
      size: 'lg',
      dialogClass: 'wmp-modal-dialog--review-lens-package'
    });
  }

  function applyLensTypeFromReview(lensType) {
    if (!lensType) return;

    queueReviewFocus('lens-type');

    var pricing = store.get('pricing');

    store.set('lensType', lensType.lensTypeKey);
    store.set('lensTypeVariantId', String(lensType.variantId || ''));
    pricing.lensType = lensType.priceCents || 0;

    store.set('pricing', pricing);
    if (typeof store.recalcLenses === 'function') {
      store.recalcLenses();
    }
    rerenderReviewStep();
  }

  function openLensTypeModal() {
    if (!window.WmpModal || typeof window.WmpModal.open !== 'function') {
      store.set('editingFromReview', true);
      router.navigate('lens-type');
      return;
    }

    var state = store.getState();
    var lensTypes = getSortedLensTypes(state, state.lensPackage);
    if (!lensTypes.length) return;

    var content = document.createElement('div');
    content.className = 'wmp-review-package-modal';

    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    for (var i = 0; i < lensTypes.length; i++) {
      (function (lensType) {
        var displayName = (lensType.title || lensType.lensTypeKey || '').toString().toUpperCase();
        var card = document.createElement('button');
        card.className = 'wmp-card';
        card.setAttribute('type', 'button');
        if (state.lensType === lensType.lensTypeKey) {
          card.classList.add('wmp-card--selected');
        }

        var iconEl = document.createElement('span');
        iconEl.className = 'wmp-card__icon';
        iconEl.innerHTML = LENS_TYPE_ICONS[lensType.lensTypeKey] || LENS_TYPE_ICONS['standard'];
        card.appendChild(iconEl);

        var body = document.createElement('div');
        body.className = 'wmp-card__content';

        var title = document.createElement('span');
        title.className = 'wmp-card__title';
        title.textContent = displayName;
        body.appendChild(title);

        var desc = document.createElement('span');
        desc.className = 'wmp-card__description';
        desc.style.cssText = 'display:block;margin-top:10px;';
        desc.textContent = lensType.subtitle || LENS_TYPE_DESCRIPTIONS[lensType.lensTypeKey] || '';
        body.appendChild(desc);

        card.appendChild(body);

        var price = document.createElement('div');
        price.className = 'wmp-card__price';
        if (lensType.priceCents === 0) {
          price.textContent = 'Free';
        } else if (lensType.comparePriceCents && lensType.comparePriceCents > lensType.priceCents) {
          var sale = document.createElement('span');
          sale.className = 'wmp-card__price--sale';
          sale.textContent = store.formatPrice(lensType.priceCents || 0);
          price.appendChild(sale);
          price.appendChild(document.createTextNode(' '));

          var original = document.createElement('span');
          original.className = 'wmp-card__price-original';
          original.textContent = store.formatPrice(lensType.comparePriceCents || 0);
          price.appendChild(original);
        } else {
          price.textContent = store.formatPrice(lensType.priceCents || 0);
        }
        card.appendChild(price);

        card.addEventListener('click', function () {
          applyLensTypeFromReview(lensType);
          window.WmpModal.close();
        });

        list.appendChild(card);
      })(lensTypes[i]);
    }

    content.appendChild(list);

    window.WmpModal.open({
      title: 'CHOOSE LENS TYPE',
      content: content,
      size: 'lg',
      dialogClass: 'wmp-modal-dialog--review-lens-package'
    });
  }

  function render(container) {
    var state = store.getState();
    var isNonRx = state.prescriptionType === 'non-prescription';

    var root = document.getElementById('wmp-prescription-flow');
    var questionIconUrl = root ? root.getAttribute('data-question-icon') : '';
    var penIconUrl = root ? root.getAttribute('data-pen-icon') : '';
    var confirmInfoBubbleText = root ? (root.getAttribute('data-review-confirmation-info-bubble') || '') : '';
    var confirmInfoBubbleContent = decodeHtmlEntities(confirmInfoBubbleText) ||
      'Before submitting your prescription, please verify that it is current and hasn\'t expired. By ticking the box and proceeding, you agree to our Privacy Policy and Terms & Conditions.';
    var infoIconHtml = questionIconUrl
      ? '<img src="' + questionIconUrl + '" alt="" aria-hidden="true" width="16" height="16" loading="eager">'
      : '?';
    editIconHtml = penIconUrl
      ? '<img src="' + penIconUrl + '" alt="Edit" width="16" height="16" loading="eager">'
      : PENCIL_SVG;

    // Heading
    var heading = document.createElement('h2');
    heading.className = 'wmp-flow__step-heading';
    heading.textContent = 'REVIEW YOUR ORDER';
    container.appendChild(heading);

    // Mobile product image (hidden on desktop, visible on mobile)
    var mobileProduct = document.createElement('div');
    mobileProduct.className = 'wmp-review-mobile-product';
    if (state.product.image) {
      var prodImg = document.createElement('img');
      prodImg.src = state.product.image;
      prodImg.alt = state.product.title;
      prodImg.loading = 'eager';
      mobileProduct.appendChild(prodImg);
    }
    var prodInfo = document.createElement('div');
    prodInfo.className = 'wmp-review-mobile-product__info';
    var variantText = state.product.variant || '';
    var lensLabel = resolveLensPackageLabel(state) || '';
    if (lensLabel) variantText += ' / ' + lensLabel + ' Lens';
    prodInfo.innerHTML = '<span class="wmp-review-mobile-product__title">' +
      (state.product.title || '') + '</span>' +
      '<span class="wmp-review-mobile-product__variant">' +
      variantText + '</span>';
    mobileProduct.appendChild(prodInfo);
    container.appendChild(mobileProduct);

    // Order summary table
    var table = document.createElement('div');
    table.className = 'wmp-review-table';

    // Frame row — pencil expands inline color swatches (spec FRAME ROW)
    buildFrameRow(table, state, loadFrameVariants(state));

    // Prescription type row
    var rxLabels = buildRxTypeLabels();
    addRow(table, 'Prescription', rxLabels[state.prescriptionType] || state.prescriptionType, null, null);

    // Lens Package row
    addRow(table, 'Lens Package', resolveLensPackageLabel(state), null, getLensPackagePrice(state), openLensPackageModal);

    // Lens Type row
    addRow(table, 'Lens Type', resolveLensTypeLabel(state), null, getLensTypePrice(state), openLensTypeModal);

    // Accessories row
    if (state.accessories.length > 0) {
      var accNames = state.accessories.map(function (k) { return ACCESSORY_LABELS[k] || k; }).join(', ');
      addRow(table, 'Accessories', accNames, 'accessories', store.formatPrice(state.pricing.accessories));
    }

    container.appendChild(table);

    // Prescription Details accordion (prescription flows only)
    if (!isNonRx) {
      var details = document.createElement('details');
      details.className = 'wmp-review-rx';

      var summary = document.createElement('summary');
      summary.className = 'wmp-review-rx__summary';
      summary.innerHTML = '<span>PRESCRIPTION DETAILS</span> ' + CHEVRON_SVG;
      details.appendChild(summary);

      var rxGrid = buildRxGrid(state);
      details.appendChild(rxGrid);

      container.appendChild(details);
    }

    // Confirmation checkbox (prescription flows only)
    if (!isNonRx) {
      var confirmWrap = document.createElement('div');
      confirmWrap.className = 'wmp-review-confirm';

      var confirmLabel = document.createElement('label');
      confirmLabel.className = 'wmp-review-confirm__label';

      confirmCheckbox = document.createElement('input');
      confirmCheckbox.type = 'checkbox';
      confirmCheckbox.className = 'wmp-review-confirm__input wmp-checkbox';

      var confirmText = document.createElement('span');
      confirmText.className = 'wmp-review-confirm__text';
      confirmText.textContent = 'I confirm that this information is correct and taken from a valid prescription.';

      var confirmInfo = document.createElement('button');
      confirmInfo.className = 'wmp-card__info';
      confirmInfo.type = 'button';
      confirmInfo.innerHTML = infoIconHtml;
      confirmInfo.setAttribute('aria-label', 'More information about prescription confirmation');
      confirmInfo.setAttribute('aria-expanded', 'false');
      confirmInfo.style.marginLeft = '4px';
      bindReviewInfoBubble(confirmInfo, confirmInfoBubbleContent);

      confirmLabel.appendChild(confirmCheckbox);
      confirmLabel.appendChild(confirmText);
      confirmWrap.appendChild(confirmLabel);
      confirmWrap.appendChild(confirmInfo);
      container.appendChild(confirmWrap);
    }

    // Mobile fixed footer wrapper (wraps subtotal, actions, and trust badges)
    var mobileFixed = document.createElement('div');
    mobileFixed.className = 'wmp-review-mobile-footer';

    // Mobile subtotal (shown only on mobile where footer is hidden)
    var subtotalMobile = document.createElement('div');
    subtotalMobile.className = 'wmp-review-mobile-subtotal';
    var subtotalValue = state.pricing.frame + state.pricing.lenses + state.pricing.accessories;
    subtotalMobile.innerHTML = '<span>SUBTOTAL:</span><span>' + store.formatPrice(subtotalValue) + '</span><span class="wmp-flow__chevron wmp-flow__chevron--open" aria-hidden="true">' + MOBILE_SUBTOTAL_CHEVRON_SVG + '</span>';
    subtotalMobile.setAttribute('role', 'button');
    subtotalMobile.setAttribute('tabindex', '0');
    subtotalMobile.setAttribute('aria-expanded', 'true');
    mobileFixed.appendChild(subtotalMobile);

    // Mobile price breakdown (under subtotal)
    var mobilePriceBreakdown = document.createElement('div');
    mobilePriceBreakdown.className = 'wmp-flow__mobile-price-breakdown wmp-review-mobile-price-breakdown';
    var accessoryTotal = Number(state.pricing.accessories || 0);
    var hasSelectedAccessories = Array.isArray(state.accessories) && state.accessories.length > 0;
    var showAccessoryPrice = hasSelectedAccessories && accessoryTotal > 0;
    var accessoryDisplay = showAccessoryPrice ? store.formatPrice(accessoryTotal) : '\u2014';
    mobilePriceBreakdown.innerHTML =
      '<div class="wmp-flow__price-row">' +
        '<span class="wmp-flow__price-label">Frame</span>' +
        '<span class="wmp-flow__price-value">' + store.formatPrice(state.pricing.frame) + '</span>' +
      '</div>' +
      '<div class="wmp-flow__price-row">' +
        '<span class="wmp-flow__price-label">Lenses</span>' +
        '<span class="wmp-flow__price-value">' + store.formatPrice(state.pricing.lenses) + '</span>' +
      '</div>' +
      '<div class="wmp-flow__price-row">' +
        '<span class="wmp-flow__price-label">Accessory</span>' +
        '<span class="wmp-flow__price-value">' + accessoryDisplay + '</span>' +
      '</div>';
    mobileFixed.appendChild(mobilePriceBreakdown);

    container.appendChild(mobileFixed);

    // Prepare processing note and last-step check now so mobile can render it
    var flowRoot = document.getElementById('wmp-prescription-flow');
    var noteAttr = isNonRx ? 'data-processing-note-non-rx' : 'data-processing-note';
    var processingNote = flowRoot ? flowRoot.getAttribute(noteAttr) : '';
    var seq = typeof store.getStepSequence === 'function' ? store.getStepSequence() : [];
    var currentStep = state.currentStep || store.get('currentStep');
    var isLastStep = seq.length > 0 && seq.indexOf(currentStep) === seq.length - 1;

    // Action buttons
    var btnGroup = document.createElement('div');
    btnGroup.className = 'wmp-review-actions';

    checkoutBtn = document.createElement('button');
    checkoutBtn.className = 'wmp-btn wmp-btn--primary wmp-btn--xl wmp-btn--full';
    checkoutBtn.setAttribute('type', 'button');
    checkoutBtn.textContent = 'CHECKOUT';
    checkoutBtn.addEventListener('click', function () { onSubmit('checkout'); });

    // Disable buttons by default if confirmation checkbox is required and not checked
    var shouldDisable = !isNonRx && confirmCheckbox && !confirmCheckbox.checked;
    checkoutBtn.disabled = shouldDisable;
    btnGroup.appendChild(checkoutBtn);

    cartBtn = document.createElement('button');
    cartBtn.className = 'wmp-btn wmp-btn--outline wmp-btn--xl wmp-btn--full';
    cartBtn.setAttribute('type', 'button');
    cartBtn.textContent = 'ADD TO CART';
    cartBtn.addEventListener('click', function () { onSubmit('cart'); });
    cartBtn.disabled = shouldDisable;
    btnGroup.appendChild(cartBtn);

    // Inline submit error (hidden until a validation/cart failure occurs).
    submitErrorEl = document.createElement('p');
    submitErrorEl.className = 'wmp-review-submit-error';
    submitErrorEl.setAttribute('role', 'alert');
    submitErrorEl.style.cssText = 'display:none;color:#c0392b;font-size:13px;margin:8px 0 0;text-align:center;';
    btnGroup.appendChild(submitErrorEl);

    // If the confirmation checkbox exists, toggle button disabled state on change
    if (confirmCheckbox) {
      confirmCheckbox.addEventListener('change', function () {
        var disabled = !confirmCheckbox.checked;
        checkoutBtn.disabled = disabled;
        cartBtn.disabled = disabled;
        var confirmControl = getConfirmControl();
        if (!disabled && confirmControl) {
          confirmControl.classList.remove('wmp-review-confirm--error');
        }
      });
    }

    mobileFixed.appendChild(btnGroup);

    // (mobile processing note will be appended after trust badges)

    // Trust badges — region-conditional
    var region = store.get('region');
    var i18n = window.WmpI18n || {};
    var badgeStrings = i18n.trust_badges || {};
    var shippingBadgeText = badgeStrings.free_shipping || 'Free 2 Day Shipping';
    var shippingTextElement = document.querySelector('.shipping_text:not(.hidden), .shipping_text_international:not(.hidden)');
    var shippingInfoText = shippingTextElement ? shippingTextElement.innerHTML.trim() : '';

    if (region === 'us' || region === 'ca') {
      var badges = document.createElement('div');
      badges.className = 'wmp-trust-badges';

      if (!isNonRx && region === 'us') {
        var hsaBadge = document.createElement('span');
        hsaBadge.className = 'wmp-trust-badge';
        hsaBadge.innerHTML = CHECK_BORDER_SVG + ' ' + (badgeStrings.hsa_fsa || 'HSA | FSA Eligible');
        badges.appendChild(hsaBadge);
      }

      var shipBadge = document.createElement('span');
      shipBadge.className = 'wmp-trust-badge';
      shipBadge.innerHTML = BOX_SVG + ' ' + shippingBadgeText;

      var shipInfo = document.createElement('button');
      shipInfo.className = 'wmp-card__info';
      shipInfo.type = 'button';
      shipInfo.innerHTML = infoIconHtml;
      shipInfo.setAttribute('aria-label', 'More information about ' + shippingBadgeText);
      shipInfo.setAttribute('aria-expanded', 'false');
      shipInfo.style.marginLeft = '6px';
      shipInfo.style.display = 'none';
      // bindReviewInfoBubble(shipInfo, shippingInfoText);
      shipBadge.appendChild(shipInfo);
      badges.appendChild(shipBadge);

      mobileFixed.appendChild(badges);

      // Mobile processing note (show under trust badges on final step)
      if (processingNote && isLastStep) {
        var mobileNoteEl = document.createElement('div');
        mobileNoteEl.className = 'wmp-flow__processing-note wmp-review-processing-note';
        var mobileNoteP = document.createElement('div');
        mobileNoteP.innerHTML = decodeHtmlEntities(processingNote);
        mobileNoteEl.appendChild(mobileNoteP);
        mobileFixed.appendChild(mobileNoteEl);
      }
    } else if (region === 'intl') {
      var intlShip = document.createElement('div');
      intlShip.className = 'wmp-trust-badges';
      var intlBadge = document.createElement('span');
      intlBadge.className = 'wmp-trust-badge';
      intlBadge.innerHTML = BOX_SVG + ' ' + shippingBadgeText;

      var intlInfo = document.createElement('button');
      intlInfo.className = 'wmp-card__info';
      intlInfo.type = 'button';
      intlInfo.innerHTML = infoIconHtml;
      intlInfo.setAttribute('aria-label', 'More information about ' + shippingBadgeText);
      intlInfo.setAttribute('aria-expanded', 'false');
      intlInfo.style.marginLeft = '6px';
      intlInfo.style.display = 'none';
      bindReviewInfoBubble(intlInfo, shippingInfoText);
      intlBadge.appendChild(intlInfo);
      intlShip.appendChild(intlBadge);
      mobileFixed.appendChild(intlShip);

      // Mobile processing note for intl (show under trust badges on final step)
      if (processingNote && isLastStep) {
        var mobileNoteElIntl = document.createElement('div');
        mobileNoteElIntl.className = 'wmp-flow__processing-note wmp-review-processing-note';
        var mobileNotePIntl = document.createElement('div');
        mobileNotePIntl.innerHTML = decodeHtmlEntities(processingNote);
        mobileNoteElIntl.appendChild(mobileNotePIntl);
        mobileFixed.appendChild(mobileNoteElIntl);
      }
    }

    var toggleMobileFooter = function () {
      var isCollapsed = mobileFixed.classList.toggle('wmp-review-mobile-footer--collapsed');
      subtotalMobile.setAttribute('aria-expanded', String(!isCollapsed));
      var subtotalChevron = subtotalMobile.querySelector('.wmp-flow__chevron');
      if (subtotalChevron) {
        subtotalChevron.classList.toggle('wmp-flow__chevron--open', !isCollapsed);
      }
    };

    subtotalMobile.addEventListener('click', toggleMobileFooter);
    subtotalMobile.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleMobileFooter();
      }
    });

    restoreQueuedReviewFocus();

    // (moved mobile processing note rendering earlier, no-op here)
  }

  /* -----------------------------------------------------------------------
     Table row builder
     ----------------------------------------------------------------------- */
  function addRow(table, label, value, editStep, price, editAction) {
    var row = document.createElement('div');
    row.className = 'wmp-review-table__row';
    row.tabIndex = -1;
    row.setAttribute('data-review-row', getReviewRowKey(label));
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', label);
    if (label?.toLowerCase() === 'prescription') {
      row.className = row.className + " wmp-review-table__row--prescription";
    }

    var labelEl = document.createElement('div');
    labelEl.className = 'wmp-review-table__label';
    labelEl.textContent = label;
    row.appendChild(labelEl);

    var valueEl = document.createElement('div');
    valueEl.className = 'wmp-review-table__value';
    valueEl.textContent = value || '';
    row.appendChild(valueEl);

    var editEl = document.createElement('div');
    editEl.className = 'wmp-review-table__edit';
    if (editStep || typeof editAction === 'function') {
      var editBtn = document.createElement('button');
      editBtn.setAttribute('type', 'button');
      editBtn.setAttribute('aria-label', 'Edit ' + label);
      editBtn.innerHTML = editIconHtml;
      if (typeof editAction === 'function') {
        editBtn.addEventListener('click', function () {
          editAction();
        });
      } else {
        editBtn.addEventListener('click', function () {
          store.set('editingFromReview', true);
          router.navigate(editStep);
        });
      }
      editEl.appendChild(editBtn);
    }
    row.appendChild(editEl);

    var priceEl = document.createElement('div');
    priceEl.className = 'wmp-review-table__price';
    priceEl.textContent = price || '';
    row.appendChild(priceEl);

    table.appendChild(row);
  }

  /* -----------------------------------------------------------------------
     Frame row + inline color swatches (H4)
     ----------------------------------------------------------------------- */
  function loadFrameVariants(state) {
    var el = document.getElementById('wmp-variants-config');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent) || {};
      var variants = (data.variants || []).filter(function (v) { return v && v.id; });

      // For prescription flows, filter frame variants to the currently selected lens color
      try {
        var selectedLens = null;
        // Prefer explicit state or DOM fallback
        if (state && state.product && state.product.lensColor) selectedLens = String(state.product.lensColor).trim();
        if (!selectedLens) {
          var elLens = document.getElementById('selected-lens-color');
          if (elLens) selectedLens = String(elLens.textContent || elLens.innerText || '').trim();
        }
        if (selectedLens) {
          var s = selectedLens.toLowerCase();
          var filtered = variants.filter(function (v) {
            return v.lensColor && String(v.lensColor).toLowerCase().trim() === s;
          });
          // If we found matches for that lens, return them; otherwise fall back to all variants
          if (filtered && filtered.length) return filtered;
        }
      } catch (e) {
        // ignore and fall through to return full list
      }

      return variants;
    } catch (e) {
      return [];
    }
  }

  function framePriceHtml(priceCents, compareCents) {
    if (compareCents && compareCents > priceCents) {
      return '<span class="wmp-card__price--sale">' + store.formatPrice(priceCents) +
        '</span> <span class="wmp-card__price-original">' + store.formatPrice(compareCents) + '</span>';
    }
    return store.formatPrice(priceCents);
  }

  function buildFrameRow(table, state, variants) {
    var row = document.createElement('div');
    row.className = 'wmp-review-table__row wmp-review-table__row--frame';
    row.tabIndex = -1;
    row.setAttribute('data-review-row', 'frame');
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Frame');

    var labelEl = document.createElement('div');
    labelEl.className = 'wmp-review-table__label';
    labelEl.textContent = 'Frame';
    row.appendChild(labelEl);

    var valueEl = document.createElement('div');
    valueEl.className = 'wmp-review-table__value wmp-review-table__value--frame';
    valueEl.setAttribute('data-frame-value', '');
    var titleEl = document.createElement('div');
    titleEl.className = 'wmp-review-frame-value__title';
    var frameTitle = sanitizeTitle(state.product.title || '');
    var frameVariant = sanitizeTitle(state.product.variant || '');
    titleEl.textContent = frameTitle + (frameVariant ? ' | ' + frameVariant : '');
    valueEl.appendChild(titleEl);
    row.appendChild(valueEl);

    var editEl = document.createElement('div');
    editEl.className = 'wmp-review-table__edit';

    var priceEl = document.createElement('div');
    priceEl.className = 'wmp-review-table__price';
    priceEl.setAttribute('data-frame-price', '');
    priceEl.textContent = store.formatPrice(state.pricing.frame);

    var editBtn = document.createElement('button');
    editBtn.setAttribute('type', 'button');
    editBtn.setAttribute('aria-label', 'Edit Frame color');
    editBtn.innerHTML = editIconHtml;
    if (variants.length <= 1) {
      editBtn.classList.add('disabled');
      editBtn.disabled = true;
    }
    editEl.appendChild(editBtn);

    // Only offer the swatch panel when there's more than one color to pick.
    var panel = null;
    if (variants.length > 1) {
      panel = buildSwatchPanel(state, variants, titleEl, priceEl);
      valueEl.appendChild(panel);

      editBtn.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        row.classList.toggle('wmp-review-table__row--frame-open', !panel.hidden);
      });
    }

    row.appendChild(editEl);
    row.appendChild(priceEl);
    table.appendChild(row);
  }

  function buildSwatchPanel(state, variants, titleEl, priceEl) {
    var panel = document.createElement('div');
    panel.className = 'wmp-review-swatches';
    panel.hidden = true;

    var label = document.createElement('div');
    label.className = 'wmp-review-swatches__label';
    label.setAttribute('data-swatch-color', '');
    label.textContent = state.product.variant || '';
    panel.appendChild(label);

    var grid = document.createElement('div');
    grid.className = 'wmp-review-swatches__grid';

    var selectedId = String(state.product.variantId || '');

    variants.forEach(function (v) {
      var sw = document.createElement('button');
      sw.className = 'wmp-review-swatch';
      sw.setAttribute('type', 'button');
      sw.setAttribute('data-variant-id', String(v.id));
      sw.setAttribute('aria-label', v.color || v.title);
      sw.title = v.color || v.title;
      if (String(v.id) === selectedId) sw.classList.add('wmp-review-swatch--selected');
      if (v.available === false) sw.classList.add('wmp-review-swatch--soldout');
      if (v.image) {
        sw.style.backgroundImage = 'url(' + v.image + ')';
      }
      sw.addEventListener('click', function () {
        var sel = grid.querySelectorAll('.wmp-review-swatch--selected');
        for (var i = 0; i < sel.length; i++) sel[i].classList.remove('wmp-review-swatch--selected');
        sw.classList.add('wmp-review-swatch--selected');
        applyFrameVariant(v, titleEl, priceEl, label);
      });
      grid.appendChild(sw);
    });

    panel.appendChild(grid);
    return panel;
  }

  // Apply a chosen color everywhere in real time: store, left panel image/price,
  // mobile thumb, the Review frame row, and the running subtotal.
  function applyFrameVariant(v, titleEl, priceEl, swatchLabel) {
    var product = store.get('product') || {};
    product.variantId = v.id;
    product.variant = v.color || v.title;
    if (v.image) product.image = v.image;
    product.price = v.priceCents || 0;
    product.compare = v.comparePriceCents || 0;
    store.set('product', product);

    var pricing = store.get('pricing');
    pricing.frame = v.priceCents || 0;
    store.set('pricing', pricing); // fires onPricingChange → left panel + mobile

    // Review frame row
    if (titleEl) {
      var tTitle = sanitizeTitle(product.title || '');
      var tVariant = sanitizeTitle(product.variant || '');
      titleEl.textContent = tTitle + (tVariant ? ' | ' + tVariant : '');
    }
    if (priceEl) priceEl.textContent = store.formatPrice(product.price);
    if (swatchLabel) swatchLabel.textContent = product.variant;

    // Product images + color name across the shell
    setImgSrc('.wmp-flow__product-image img', product.image);
    setImgSrc('.wmp-flow__mobile-thumb', product.image);
    setImgSrc('.wmp-review-mobile-product img', product.image);
    setText('.wmp-flow__product-variant', product.variant);
    setText('.wmp-flow__mobile-product-variant', product.variant);

    var currentState = store.getState();
    var mobileReviewVariant = product.variant || '';
    var mobileReviewLensLabel = resolveLensPackageLabel(currentState) || '';
    if (mobileReviewLensLabel) mobileReviewVariant += ' / ' + mobileReviewLensLabel + ' Lens';
    setText('.wmp-review-mobile-product__variant', mobileReviewVariant);
  }

  function setImgSrc(sel, src) {
    if (!src) return;
    var el = document.querySelector(sel);
    if (el) el.setAttribute('src', src);
  }

  function setText(sel, text) {
    var el = document.querySelector(sel);
    if (el) el.textContent = text;
  }

  /* -----------------------------------------------------------------------
     Read-only Rx grid
     ----------------------------------------------------------------------- */
  function buildRxGrid(state) {
    var rx = state.rxValues;
    var showAdd = state.prescriptionType === 'progressive' || state.prescriptionType === 'reading';
    var hasTwoPDs = !!rx.hasTwoPDs;

    var grid = document.createElement('div');
    grid.className = 'wmp-review-rx__grid';

    // Header
    var headerRow = document.createElement('div');
    headerRow.className = 'wmp-review-rx__row wmp-review-rx__row--header' + (showAdd ? ' wmp-review-rx__row--with-add' : '');
    headerRow.innerHTML = '<span></span><span>SPH</span><span>CYL</span><span>AXIS</span>' +
      (showAdd ? '<span>ADD</span>' : '') +
      '<span>PD</span>';
    grid.appendChild(headerRow);

    var rowsGrid = document.createElement('div');
    rowsGrid.className = 'wmp-review-rx__rows' +
      (showAdd ? ' wmp-review-rx__rows--with-add' : '') +
      (hasTwoPDs ? '' : ' wmp-review-rx__rows--merged-pd');

    // OD row cells
    rowsGrid.innerHTML += '<span class="wmp-review-rx__eye"><span class="wmp-review-rx__eye-code">OD</span><span class="wmp-review-rx__eye-name">Right Eye</span></span>' +
      '<span>' + formatVal(rx.od.sph) + '</span>' +
      '<span>' + formatVal(rx.od.cyl) + '</span>' +
      '<span>' + formatVal(rx.od.axis) + '</span>' +
      (showAdd ? '<span>' + formatVal(rx.od.add) + '</span>' : '') +
      (hasTwoPDs
        ? '<span>' + formatVal(rx.rpd) + '</span>'
        : '<span class="wmp-review-rx__cell--pd-merged">' + formatVal(rx.pd) + '</span>');

    // OS row cells
    rowsGrid.innerHTML += '<span class="wmp-review-rx__eye"><span class="wmp-review-rx__eye-code">OS</span><span class="wmp-review-rx__eye-name">Left Eye</span></span>' +
      '<span>' + formatVal(rx.os.sph) + '</span>' +
      '<span>' + formatVal(rx.os.cyl) + '</span>' +
      '<span>' + formatVal(rx.os.axis) + '</span>' +
      (showAdd ? '<span>' + formatVal(rx.os.add) + '</span>' : '') +
      (hasTwoPDs ? '<span>' + formatVal(rx.lpd) + '</span>' : '');

    grid.appendChild(rowsGrid);

    return grid;
  }

  function formatVal(val) {
    if (val === null || val === undefined || val === '') return '\u2014';
    if (typeof val === 'number') {
      var s = val.toFixed(2);
      if (val > 0 && s.charAt(0) !== '+') s = '' + s;
      return s;
    }
    return String(val);
  }

  /* -----------------------------------------------------------------------
     Price helpers
     ----------------------------------------------------------------------- */
  function getLensPackagePrice(state) {
    var price = state.pricing.lensPackage || 0;
    return price > 0 ? store.formatPrice(price) : 'Free';
  }

  function getLensTypePrice(state) {
    var price = state.pricing.lensType || 0;
    return price > 0 ? store.formatPrice(price) : 'Free';
  }

  /* -----------------------------------------------------------------------
     Build line item properties for Shopify cart
     ----------------------------------------------------------------------- */
  function buildLineItemProperties(state) {
    var rx = state.rxValues;
    var props = {};

    if (state.prescriptionType !== 'non-prescription') {
      props['OD_SPH'] = rx.od.sph != null ? rx.od.sph.toFixed(2) : '';
      props['OD_CYL'] = rx.od.cyl != null ? rx.od.cyl.toFixed(2) : '';
      props['OD_AXIS'] = rx.od.axis != null ? String(rx.od.axis) : '';
      props['OD_ADD'] = rx.od.add != null ? rx.od.add.toFixed(2) : '';
      props['OD_V_PRISM'] = rx.hasPrism && rx.prism.od.vertical ? String(rx.prism.od.vertical) : '';
      props['OD_V_Direction'] = rx.hasPrism && rx.prism.od.verticalDir ? rx.prism.od.verticalDir : '';
      props['OD_H_PRISM'] = rx.hasPrism && rx.prism.od.horizontal ? String(rx.prism.od.horizontal) : '';
      props['OD_H_Direction'] = rx.hasPrism && rx.prism.od.horizontalDir ? rx.prism.od.horizontalDir : '';
      props['OD_PD'] = rx.hasTwoPDs ? (rx.rpd != null ? rx.rpd.toFixed(1) : '') : '';
      props['OS_SPH'] = rx.os.sph != null ? rx.os.sph.toFixed(2) : '';
      props['OS_CYL'] = rx.os.cyl != null ? rx.os.cyl.toFixed(2) : '';
      props['OS_AXIS'] = rx.os.axis != null ? String(rx.os.axis) : '';
      props['OS_ADD'] = rx.os.add != null ? rx.os.add.toFixed(2) : '';
      props['OS_V_PRISM'] = rx.hasPrism && rx.prism.os.vertical ? String(rx.prism.os.vertical) : '';
      props['OS_V_Direction'] = rx.hasPrism && rx.prism.os.verticalDir ? rx.prism.os.verticalDir : '';
      props['OS_H_PRISM'] = rx.hasPrism && rx.prism.os.horizontal ? String(rx.prism.os.horizontal) : '';
      props['OS_H_Direction'] = rx.hasPrism && rx.prism.os.horizontalDir ? rx.prism.os.horizontalDir : '';
      props['OS_PD'] = rx.hasTwoPDs ? (rx.lpd != null ? rx.lpd.toFixed(1) : '') : '';
      props['PD'] = !rx.hasTwoPDs && rx.pd != null ? rx.pd.toFixed(1) : '';

      // Canada: issue date + prescribing doctor are mandatory for CA orders and
      // must reach the rx app. Keys are provisional pending the rx-app contract;
      // change them here only (single source) if the lab expects different names.
      if (store.get('region') === 'ca' && rx.canada) {
        props['RX_ISSUE_DATE'] = rx.canada.issueDate || '';
        props['DOCTOR_FIRST_NAME'] = rx.canada.doctorFirst || '';
        props['DOCTOR_LAST_NAME'] = rx.canada.doctorLast || '';
      }
    }

    props['LENSES'] = LENSES_FIELD_MAP[state.prescriptionType] || '';

    return props;
  }

  function buildOrderAttributes(state) {
    var rx = state.rxValues || {};
    var orderRx = rx.orderAttributes || {};
    return {
      RX_ISSUE_DATE: orderRx.issueDate || '',
      DOCTOR_NAME: orderRx.doctorName || ''
    };
  }

  function generatePrescriptionKey() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'rx-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function buildPrescriptionAttributePayload(state, packageLabel, lensTypeLabel) {
    var payload = buildLineItemProperties(state);
    var orderAttributes = buildOrderAttributes(state);

    payload['product_1'] = packageLabel;
    payload['product_2'] = state.lensType !== 'standard' ? lensTypeLabel : '';
    payload['_lens_package'] = packageLabel;
    payload['_lens_type'] = lensTypeLabel;
    payload['_prescription_type'] = state.prescriptionType || '';

    if (orderAttributes.RX_ISSUE_DATE) {
      payload['RX_ISSUE_DATE'] = orderAttributes.RX_ISSUE_DATE;
    }

    if (orderAttributes.DOCTOR_NAME) {
      payload['DOCTOR_NAME'] = orderAttributes.DOCTOR_NAME;
    }

    return sortLineItemProperties(payload);
  }

  function updateCartAttributes(attrs, sections) {
    var body = { attributes: attrs };
    if (sections && sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart attribute update failed (' + res.status + ')');
      return res.json();
    }).then(function (cart) {
      var savedAttrs = (cart && cart.attributes) || {};
      return cart;
    });
  }

  /* -----------------------------------------------------------------------
     Prescription attributes keep the legacy fixed field order so downstream
     consumers still receive the documented keys in a predictable sequence,
     while the line item itself only stores the private reference key.
     ----------------------------------------------------------------------- */
  var LINE_ITEM_PROPERTY_ORDER = [
    'OD_SPH', 'OD_CYL', 'OD_AXIS', 'OD_ADD',
    'OD_V_PRISM', 'OD_V_Direction', 'OD_H_PRISM', 'OD_H_Direction', 'OD_PD',
    'OS_SPH', 'OS_CYL', 'OS_AXIS', 'OS_ADD',
    'OS_V_PRISM', 'OS_V_Direction', 'OS_H_PRISM', 'OS_H_Direction', 'OS_PD',
    'PD', 'product_1', 'product_2', '_main_product', '_uniqueId', '_prescription_key', 'LENSES'
  ];

  function sortLineItemProperties(props) {
    var orderMap = {};
    for (var i = 0; i < LINE_ITEM_PROPERTY_ORDER.length; i++) {
      orderMap[LINE_ITEM_PROPERTY_ORDER[i].toLowerCase()] = i;
    }
    var entries = Object.keys(props).map(function (key, idx) {
      var rank = orderMap[key.toLowerCase()];
      return { key: key, idx: idx, rank: rank === undefined ? Infinity : rank };
    });
    // Stable sort: known keys by contract order, unknown keys kept in insertion order at the end.
    entries.sort(function (a, b) {
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.idx - b.idx;
    });
    var sorted = {};
    for (var j = 0; j < entries.length; j++) {
      sorted[entries[j].key] = props[entries[j].key];
    }
    return sorted;
  }

  function getConfiguredGiftVariantIds() {
    var giftConfig = window.ProductBundlerOptionsConfig || {};

    return [
      giftConfig.cartGiftProduct,
      giftConfig.cartPrescriptionGiftProduct,
      giftConfig.cart_different_gift_product
    ].map(function (id) {
      return String(id || '');
    }).filter(Boolean);
  }

  function isConfiguredGiftAccessory(acc) {
    if (!acc) return false;

    var variantId = String(acc.variantId || '');
    var giftVariantIds = getConfiguredGiftVariantIds();

    return giftVariantIds.indexOf(variantId) !== -1;
  }

  function isStandaloneAccessory(acc) {
    if (!acc) return false;

    var key = String(acc.key || '').toLowerCase();
    var title = String(acc.title || '').toLowerCase();
    var standaloneKeys = ['premium-foldable-case', 'cleaning-kit'];
    var standaloneTitles = ['premium foldable case', 'cleaning kit', 'cleaning & repair kit'];

    return standaloneKeys.indexOf(key) !== -1 || standaloneTitles.indexOf(title) !== -1;
  }

  function buildAccessoryLineItemProperties(acc, uniqueId, prescriptionType) {
    if (isConfiguredGiftAccessory(acc)) {
      return { _gift_product: 'true' };
    }

    if (isStandaloneAccessory(acc)) {
      return undefined;
    }

    return { _uniqueId: uniqueId, _children: true, _prescription_type: prescriptionType };
  }

  /* -----------------------------------------------------------------------
     Submit (checkout or add to cart)
     ----------------------------------------------------------------------- */
  function showSubmitError(message) {
    if (!submitErrorEl) return;
    submitErrorEl.textContent = message;
    submitErrorEl.style.display = 'block';
  }

  function clearSubmitError() {
    if (!submitErrorEl) return;
    submitErrorEl.textContent = '';
    submitErrorEl.style.display = 'none';
  }

  // Toggle the in-flight state: disable both submit buttons and show a processing
  // label on the one that was clicked, or restore them on failure.
  function setSubmitting(isSubmitting, mode) {
    submitting = isSubmitting;
    if (checkoutBtn) checkoutBtn.disabled = isSubmitting;
    if (cartBtn) cartBtn.disabled = isSubmitting;
    if (isSubmitting) {
      if (mode === 'checkout' && checkoutBtn) checkoutBtn.textContent = 'PROCESSING…';
      if (mode === 'cart' && cartBtn) cartBtn.textContent = 'ADDING…';
    } else {
      if (checkoutBtn) checkoutBtn.textContent = 'CHECKOUT';
      if (cartBtn) cartBtn.textContent = 'ADD TO CART';
    }
  }

  function onSubmit(mode) {
    if (submitting) return; // guard against double-submit while a request is in flight
    clearSubmitError();

    var state = store.getState();
    var isNonRx = state.prescriptionType === 'non-prescription';

    // Validate confirmation checkbox for prescription flows
    if (!isNonRx && confirmCheckbox && !confirmCheckbox.checked) {
      var confirmControl = getConfirmControl();
      if (confirmControl) confirmControl.classList.add('wmp-review-confirm--error');
      confirmCheckbox.focus();
      return;
    }

    var config = window.WmpProductsConfig;
    var frameVariantId = getFrameVariantId();
    if (!frameVariantId) {
      console.error('WMP: missing frame variant ID');
      showSubmitError('We could not load this frame. Please refresh the page and try again.');
      return;
    }

    var uniqueId = Date.now();
    var prescriptionKey = generatePrescriptionKey();
    var packageLabel = resolveLensPackageLabel(state);
    var lensTypeLabel = resolveLensTypeLabel(state);
    var prescriptionAttributePayload = buildPrescriptionAttributePayload(state, packageLabel, lensTypeLabel);
    var prescriptionAttributes = {};
    prescriptionAttributes[prescriptionKey] = JSON.stringify(prescriptionAttributePayload);
    window.__WMP_LAST_PRESCRIPTION_ATTRIBUTE__ = {
      key: prescriptionKey,
      payload: prescriptionAttributePayload
    };

    var prescriptionType = state.prescriptionType || '';

    var properties = {
      _main_product: true,
      _uniqueId: uniqueId,
      _prescription_key: prescriptionKey,
      _prescription_type: prescriptionType
    };

    var items = [{
      id: frameVariantId,
      quantity: 1,
      properties: sortLineItemProperties(properties)
    }];

    // Lens package line item — the variant ID is carried from the exact card the
    // user clicked (see wmp-step-lens-package.js), so there is no submit-time
    // re-matching that could silently resolve the wrong variant or none at all.
    // A selected package must resolve to a real variant; if it does not, the
    // config is broken and we abort loudly rather than ship a frame-only cart.
    var missing = [];
    if (state.lensPackage) {
      if (state.lensPackageVariantId) {
          items.push({
            id: state.lensPackageVariantId,
            quantity: 1,
            properties: { _uniqueId: uniqueId, _children: true, _prescription_type: prescriptionType, _lens_option_type: 'lens-package' }
          });
      } else {
        missing.push('lens package');
      }
    }

    // Lens type line item — also carried. A "standard" type with no upcharge
    // product legitimately has no variant (matching the legacy flow's id:null),
    // so an empty ID here is not an error: we simply add no line for it.
    if (state.lensType && state.lensTypeVariantId) {
      items.push({
        id: state.lensTypeVariantId,
        quantity: 1,
        properties: { _uniqueId: uniqueId, _children: true, _prescription_type: prescriptionType, _lens_option_type: 'lens-type' }
      });
    }

    // Prism add-on — billed as its own child line item. A stale selection must
    // never be silently omitted when its configured product becomes unavailable.
    if (state.rxValues && state.rxValues.hasPrism) {
      var prism = config && typeof config.getPrism === 'function' ? config.getPrism() : null;
      if (prism && prism.variantId) {
        items.push({
          id: prism.variantId,
          quantity: 1,
          properties: { _uniqueId: uniqueId, _children: true, _prescription_type: prescriptionType }
        });
      } else {
        missing.push('prism');
      }
    }

    if (missing.length) {
      console.error('WMP: missing variant IDs for', missing);
      showSubmitError('Some lens options are currently unavailable (' + missing.join(', ') + '). Please reselect them or contact support.');
      return;
    }

    // Accessories — one line per selected accessory
    var accessories = state.accessories || [];
    for (var i = 0; i < accessories.length; i++) {
      if (!config) break;
      var acc = config.findAccessory(accessories[i]);
      if (acc && acc.variantId) {
        items.push({
          id: acc.variantId,
          quantity: 1,
          properties: buildAccessoryLineItemProperties(acc, uniqueId, prescriptionType)
        });
      }
    }

    setSubmitting(true, mode);

    updateCartAttributes(prescriptionAttributes, ['cart-icon-bubble', 'cart-drawer'])
    .then(function () {
      return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['cart-icon-bubble', 'cart-drawer']
      })
      });
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed (' + res.status + ')');
      return res.json();
    })
    .then(function (data) {
      if (typeof store.persistRx === 'function') {
        store.persistRx();
      }
      return data;
    })
    .then(function (data) {
      if (mode === 'checkout') {
        window.location.href = '/checkout';
        return;
      }

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data || {});
      } else {
        var cartTrigger = document.querySelector('#cart-icon-bubble');
        if (cartTrigger) {
          cartTrigger.click();
        }
      }

      // For Add to Cart flow: reset state and close overlay, so next open starts from step 1.
      setSubmitting(false);
      resetFlowToFirstStep();
      closeFlowOverlay();
    })
    .catch(function (err) {
      // /cart/add.js is atomic: if any single line item is unavailable the whole
      // add fails and nothing is added. Surface that instead of failing silently.
      console.error('Cart error:', err);
      setSubmitting(false);
      showSubmitError('We couldn’t add this to your cart. One of the selected options may be out of stock. Please try again or contact support.');
    });
  }

  function closeFlowOverlay() {
    var closeBtn = document.getElementById('wmp-desktop-close') || document.getElementById('wmp-mobile-close');
    if (closeBtn && typeof closeBtn.click === 'function') {
      closeBtn.click();
      return;
    }

    var overlay = document.getElementById('wmp-flow-overlay');
    if (overlay) {
      overlay.setAttribute('hidden', '');
      document.body.classList.remove('wmp-flow-overlay-open');
    }
  }

  function resetFlowToFirstStep() {
    if (!store || typeof store.reset !== 'function') return;
    store.reset();
    var seq = typeof store.getStepSequence === 'function' ? store.getStepSequence() : [];
    var firstStep = seq.length ? seq[0] : 'prescription-type';
    store.set('currentStep', firstStep);
    store.set('completedSteps', []);
  }

  function getFrameVariantId() {
    // Prefer the color the user picked via the Review swatches.
    var product = store.get('product') || {};
    if (product.variantId) return product.variantId;

    var root = document.getElementById('wmp-prescription-flow');
    if (!root) return '';
    var id = root.getAttribute('data-product-variant-id') || '';
    if (id) return id;
    // Fallback for cases where Liquid did not populate the attribute
    var url = new URL(window.location.href);
    return url.searchParams.get('variant') || '';
  }

  function destroy() {
    confirmCheckbox = null;
    checkoutBtn = null;
    cartBtn = null;
    submitErrorEl = null;
    submitting = false;
  }

  function onContinue() {
    onSubmit('checkout');
  }

  window.WmpSteps = window.WmpSteps || {};
  window.WmpSteps['review'] = {
    render: render,
    destroy: destroy,
    onContinue: onContinue
  };
})();
